<template>
  <div class="common-slider">
    <swiper :options="swiperOption" ref="mySwiper">
      <swiper-slide v-for="banner in bannerlist" :key="banner.id">
        <img :src='"../assets/images/"+banner.name+""' @click="replaceMenu(banner.path)">
      </swiper-slide>
      <div class="swiper-pagination"  slot="pagination"></div>
    </swiper>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
  name: 'carrousel',
  props: {
    bannerlist: {
      type: Array,
      default: function () { return [] }
    }
  },
  components: {
    swiper,
    swiperSlide
  },
  data () {
    return {
      swiperOption: {
        width: window.innerWidth,
        pagination: {
          el: '.swiper-pagination',
          dynamicBullets: true,
          clickable: true
        },
        autoplay: {
          delay: 2500,
          disableOnInteraction: false
        }
      }
    }
  },
  computed: {
    swiper () {
      return this.$refs.mySwiper.swiper
    }
  },
  methods: {
    replaceMenu (menuHref) {
      if (menuHref) {
        this.$router.replace(`/${menuHref}`)
      }
    }
  }
}
</script>

<style scoped>
.common-slider img {
  width: 100%;
}
.aboutus-container .swiper-pagination {
  position: absolute;
  bottom: 20px;
}
.aboutus-container .swiper-container {
  width: 100%;
  /* height: 420px; */
  margin-bottom: -2px!important;
  overflow: hidden;
}
.swiper-pagination-bullet-active {
  background: #fff!important;
}
.swiper-slide a {
  display: block;
  width: 100%;
  height: 100%;
}
.swiper-slide img {
  position: relative;
  left: -2px;
  top: -1px;
}
</style>



// WEBPACK FOOTER //
// src/components/carousel.vue